/**
 * Error Sanitizer & Humanizer untuk FotoMomen
 * Mengubah pesan error teknis backend / Convex / Network menjadi bahasa manusia yang jelas.
 */

export function parseFriendlyError(err: unknown, defaultMessage = "Terjadi kesalahan. Silakan coba lagi."): string {
  if (!err) return defaultMessage;

  const rawMessage = err instanceof Error ? err.message : String(err);

  // 1. Convex Auth Specific Errors
  if (
    rawMessage.includes("InvalidAccountId") ||
    rawMessage.includes("InvalidSecret") ||
    rawMessage.includes("Could not find account") ||
    rawMessage.includes("Incorrect password") ||
    rawMessage.includes("auth:signIn") ||
    rawMessage.includes("Server Error Called by client")
  ) {
    return "Email atau password yang Anda masukkan salah. Silakan periksa kembali.";
  }

  if (rawMessage.includes("AccountAlreadyExists") || rawMessage.includes("already registered")) {
    return "Email ini sudah terdaftar. Silakan login menggunakan password Anda.";
  }

  if (rawMessage.includes("PasswordTooShort") || rawMessage.includes("password must be")) {
    return "Password terlalu pendek. Gunakan minimal 8 karakter.";
  }

  // 2. Authorization / Permissions
  if (rawMessage.includes("Unauthorized") || rawMessage.includes("Forbidden") || rawMessage.includes("Admin only")) {
    return "Akses ditolak. Anda tidak memiliki izin untuk melakukan tindakan ini.";
  }

  // 3. Network & Connectivity
  if (rawMessage.includes("Failed to fetch") || rawMessage.includes("NetworkError") || rawMessage.includes("ECONNREFUSED")) {
    return "Gagal terhubung ke server. Periksa koneksi internet Anda.";
  }

  // 4. Google Drive OAuth
  if (rawMessage.includes("Token exchange gagal") || rawMessage.includes("invalid_grant")) {
    return "Koneksi Google Drive kedaluwarsa atau dibatalkan. Silakan hubungkan ulang akun Google Anda.";
  }

  // 5. Payment / Midtrans
  if (rawMessage.includes("Midtrans") || rawMessage.includes("Snap")) {
    return "Layanan pembayaran sedang sibuk atau konfigurasi belum lengkap. Silakan coba sesaat lagi.";
  }

  // 6. Camera / WebRTC
  if (rawMessage.includes("NotAllowedError") || rawMessage.includes("Permission denied")) {
    return "Izin kamera ditolak. Mohon izinkan akses kamera di pengaturan browser Anda.";
  }

  if (rawMessage.includes("NotFoundError") || rawMessage.includes("DevicesNotFoundError")) {
    return "Kamera tidak ditemukan pada perangkat ini.";
  }

  // 7. General Clean-up (hilangkan prefix internal Convex jika masih ada)
  const cleaned = rawMessage
    .replace(/^\[CONVEX[^\]]*\]\s*/g, "")
    .replace(/^Error:\s*/g, "")
    .replace(/^Uncaught\s*/g, "")
    .trim();

  // Jika setelah dibersihkan masih terlalu teknis (mengandung call stack atau kurung kurawal), kembalikan default friendly
  if (cleaned.includes("at ") || cleaned.includes("{") || cleaned.includes("Server Error")) {
    return defaultMessage;
  }

  return cleaned || defaultMessage;
}
